import { useFormContext } from './form';
import { MenuItem, SelectField } from 'material-ui';
import React from 'react';
import InfoIcon from 'material-ui/svg-icons/action/info';

const styles = {
    infoIcon: {
        width: '1em',
        height: '1em',
        verticalAlign: 'middle',
        margin: '-3px 0 0 0.5em',
        color: '#dadada',
        cursor: 'pointer',
    },
};

const fittedOptions = [
    { value: null, label: undefined },
    { value: true, label: 'Yes' },
    { value: false, label: 'No' },
];

export function FormSelect({
    name,
    ...rest
}) {
    const form = useFormContext();
    const conf = form.config[name] || {};
    const value = form.values[name];

    const confOptions = conf.type === 'select-fitted' ? fittedOptions : conf.options;
    const first = confOptions[0];
    const options = first && typeof first === 'object'
        ? confOptions
        : confOptions.map(option => ({ value: option, label: option }));

    return (
        <Select
            name={name}
            value={value}
            label={conf.label}
            onChange={form.onChange}
            disabled={conf.disabled && conf.disabled(form)}
            options={options}
            {...rest}
        />
    );
}

export function Select({
    name, label, hint, value, options, onChange, ...rest
}) {
    const first = options[0];
    options = first && typeof first === 'object'
        ? options
        : options.map(option => ({ value: option, label: option }));

    return (
        <SelectField
            name={name}
            value={value || ''}
            onChange={(_e, _i, val) => onChange({ field: name, value: val })}
            floatingLabelText={
                hint
                    ? <React.Fragment>
                        {label}
                        <span data-tip={hint} style={{ pointerEvents: 'all' }}>
                            <InfoIcon style={styles.infoIcon} />
                        </span>
                    </React.Fragment>
                    : label
            }
            fullWidth
            autoWidth
            {...rest}
        >
            {options.map((option, index) => (
                <MenuItem
                    key={index}
                    value={option.value}
                    primaryText={option.label}
                />
            ))}
        </SelectField>
    );
}



// WEBPACK FOOTER //
// ./app/components/common/Form/FormSelect.jsx